<app-search-ui></app-search-ui>
<div fxLayout="column">
  <nb-card>
    <nb-card-body>
      <nb-tabset fullWidth>
        <nb-tab tabTitle="Utils">
          <nb-card id="userInfoCard" *ngIf="showSearchCard">
            <nb-card-header>
              <span class="h6">
                Select the destination account from below
              </span>
              <br>
              <br>
              <nb-form-field>
                <nb-icon nbPrefix icon="search" pack="eva"></nb-icon>
                <input type="text" nbInput (input)="searchUsers($event.target.value)">
              </nb-form-field>
            </nb-card-header>
            <nb-card-body fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="32px" fxLayoutAlign="flex-start"
              *ngIf="(custDatas$ | async) as custDatas">
              <mat-card *ngFor="let item of custDatas.docs" fxFlex="0 1 calc(33.3% - 32px)" fxFlex.lt-md="0 1 calc(50% - 32px)"
                fxFlex.lt-sm="100%" class="searchResCard mat-elevation-z8" (click)="setData(item)">
                <mat-card-content>
                    <nb-user size="large" name="{{item['emailId']?item['emailId']:item['mobile']}}"
                      [picture]="item['profilePicUrl']" color="#cccccc" showInitials="true">
                    </nb-user>
                </mat-card-content>
              </mat-card>
            </nb-card-body>
          </nb-card>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="50px" style="width: 100%;margin-top: 20px;">
          <nb-card [nbSpinner]="consolePinLoading"
        nbSpinnerStatus="success"
        nbSpinnerSize="large"
        nbSpinnerMessage=""
        >
          <nb-card-body fxLayout="column" fxLayoutAlign="center center">
              <b>Console Passcode for Today</b>
              <br>
              <h4 [cdkCopyToClipboard]="consolePinToday" nbPopover="Click to
              Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">{{consolePinToday}}</h4>
          </nb-card-body>
        </nb-card>
        <nb-card [nbSpinner]="impPasswdLoading"
        nbSpinnerStatus="success"
        nbSpinnerSize="large"
        nbSpinnerMessage=""
        *ngIf="impPasswdAllowed"
        >
          <nb-card-body fxLayout="column" fxLayoutAlign="center center">
              <b>Impersonate Password for Today</b>
              <br>
              <button nbButton size="tiny" *ngIf="!impPasswdLoading && !impPasswdLoaded" [disabled]="impPasswdDialogOpen" (click)="getImpPasswd()">View</button>
              <h4 [cdkCopyToClipboard]="impPasswd" nbPopover="Click to
              Copy" nbPopoverTrigger="hover" nbPopoverPlacement="bottom">{{impPasswd}}</h4>
              <b style="font-size: 10px;color: gray;">**Viewing the password will be considered as login attempt. Incident will be reported.</b>
          </nb-card-body>
        </nb-card>
        </div>
        <div fxLayout="row" style="width: 100%;">
          <!-- <div fxLayout="column" fxLayoutAlign="start start">
            <b style="margin-right: 10px;">Select Feature :</b>
            <nb-select placeholder="Select Feature" [(selected)]="selectedFeature" shape="round" hero status="info">
              <nb-option *ngFor="let feature of features" value="{{feature}}">{{feature}}</nb-option>
            </nb-select>
          </div> -->
          <nb-card style="min-width: 200px;margin-right: 20px;">
            <nb-card-header>
              Features
            </nb-card-header>
            <nb-list>
              <nb-list-item *ngFor="let feature of features" style="cursor: pointer;" (click)="selectFeature(feature)" [ngClass]="selectedFeature == feature ? 'feature-selected' : 'feature-normal'">
                <span>{{ feature }}</span>
                <span *ngIf="feature == 'Scene Details' && showSceneDetailsNewBanner" class="new-feature-banner">NEW</span>
              </nb-list-item>
            </nb-list>
          </nb-card>
          <div fxLayout="column" style="width: 100%;" id="utilContent">
            <nb-card *ngIf="isSupport && selectedFeature == 'Node Replacement'">
              <nb-card-body>
                  <div id="nrHolder" style="text-align: center;">
                      <b>Node Replacement :</b>
                          <br>
                          <br>
                          <nb-alert status="danger">Please make sure HUB is Online</nb-alert>
                          <br>
                          <br>
                          <div>
                              <input type="text" nbInput placeholder="Old eID" [(ngModel)]="oldEid" style="text-transform: lowercase;">
                              <nb-icon nbPrefix icon="arrow-forward-outline" pack="eva" style="margin-left: 10px;margin-right: 10px;"></nb-icon>
                              <input type="text" nbInput placeholder="New eID" [(ngModel)]="newEid" style="text-transform: lowercase;">
                              <br>
                              <br>
                              <button nbButton *ngIf="keys().length == 0" (click)="addNodeUtil()">Add</button>
                              <br>
                              <br>
                              <div *ngIf="keys().length > 0">
                                  <b>Replacing eIDs :</b>
                                  <br>
                                  <br>
                                  <ul style="list-style-type: none;line-height: 2.5em;">
                                      <li *ngFor="let key of keys()" style="display: block;margin: 20px;">
                                          <input style="width: 150px;" type="text" nbInput placeholder="New eID" [value]="key" [disabled]="true"><nb-icon nbPrefix icon="arrow-forward-outline" pack="eva" style="margin-left: 10px;margin-right: 10px;"></nb-icon> <input style="width: 150px;" type="text" nbInput placeholder="New eID" [value]="nodeIds[key].eid" [disabled]="true">
                                          <nb-checkbox style="margin-left: 20px;" [(checked)]="nodeIds[key].deductWarranty" (checkedChange)="toggledeductWarranty($event,key)">Deduct Warranty</nb-checkbox>
                                          <input type="text" nbInput placeholder="Replacement Reason" [(ngModel)]="nodeIds[key].reason" style="margin-left: 10px;width: 210px;">
                                      </li>
                                  </ul>
                                  <br>
                                  <br>
                              </div>
                          </div>
                          <div *ngIf="keys().length > 0">
                            <br>
                            <br>
                            <button nbButton status="primary" (click)="replaceNode()" [disabled]="isReplacing">Replace</button>
                          </div>
                  </div>

                  <nb-card style="margin-top: 30px;">
                    <nb-card-body>
                        <div style="text-align: center;">
                          <h6>Node Replacement History :</h6>
                          <br>
                          <input nbInput fullWidth placeholder="Enter EID" style="text-transform: lowercase;" [(ngModel)]="nrHistoryEid"/>
                          <br>
                          <br>
                          <button nbButton fullWidth status="primary" (click)="getNRHistory()" [disabled]="loadingReplacement" style="margin-left:10px;">Get Details</button>
                          <br>
                          <br>
                          <div *ngIf="dataSourceForReplacement.length">
                              <table mat-table [dataSource]="dataSourceForReplacement" class="mat-elevation-z8">
                                  <ng-container matColumnDef="oldEid">
                                      <th mat-header-cell *matHeaderCellDef> Old eID </th>
                                      <td mat-cell *matCellDef="let element"> {{element.oldEid}}({{element.oldNodeShortId}}) </td>
                                  </ng-container>
                                  <ng-container matColumnDef="newEid">
                                      <th mat-header-cell *matHeaderCellDef> New eID </th>
                                      <td mat-cell *matCellDef="let element"> {{element.newEid}}({{element.newNodeShortId}}) </td>
                                  </ng-container>
                                  <ng-container matColumnDef="invokerId">
                                      <th mat-header-cell *matHeaderCellDef> Done By </th>
                                      <td mat-cell *matCellDef="let element"> {{element.invokerId}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="reason">
                                      <th mat-header-cell *matHeaderCellDef> Reason </th>
                                      <td mat-cell *matCellDef="let element"> {{element.reason}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="customerEmail">
                                      <th mat-header-cell *matHeaderCellDef> Customer Email ID </th>
                                      <td mat-cell *matCellDef="let element"> {{element.customerEmail}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="initiationDate">
                                      <th mat-header-cell *matHeaderCellDef>Initiation Date </th>
                                      <td mat-cell *matCellDef="let element"> {{element.initiationDate != undefined ? (element.initiationDate | date:'medium'):element.initiationDate}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="completionDate">
                                      <th mat-header-cell *matHeaderCellDef>Completion Date </th>
                                      <td mat-cell *matCellDef="let element"> {{element.completionDate !==undefined ? (element.completionDate | date:'medium'):element.completionDate}} </td>
                                  </ng-container>
                                  <tr mat-header-row *matHeaderRowDef="displayedColumnsForReplacement"></tr>
                                  <tr mat-row *matRowDef="let row; columns: displayedColumnsForReplacement;"></tr>
                              </table>
                          </div>
                      </div>
                    </nb-card-body>
                  </nb-card>

              </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Provision'" [nbSpinner]="provisionLoading"
            nbSpinnerStatus="success"
            nbSpinnerSize="large"
            nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Provision DB / Test Data :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter EID" style="text-transform: lowercase;" [(ngModel)]="provisionEid"/>
                <br>
                <button nbButton fullWidth status="primary" (click)="checkProvision()" style="margin-left:10px;">Get Details</button>
                <br>
                <button nbButton fullWidth status="primary" (click)="downloadProvision()" style="margin-left:10px;">Download Provision Data</button>
                <br>
                <button nbButton fullWidth status="primary" (click)="downloadTestData()" style="margin-left:10px;">Download Test Data</button>
                <br>
                <br>
                <!-- <ag-grid-angular
                  *ngIf="provisionData"
                  style="width: 100%;"
                  class="ag-theme-balham"
                  [columnDefs]="columnDefsProvision"
                  [defaultColDef]="defaultColDef"
                  [rowData]="provisionData"
                  [rowSelection]="'multiple'"
                  [domLayout]="domLayout"
                  [animateRows]="true"
                  [enableCellTextSelection]=true
                  (gridReady)="onGridReady($event)"> 
                  </ag-grid-angular>
                -->
                <nb-card *ngIf="provisionData" style="width: 100%;">
                  <nb-card-body>
                    <table class="provisionData">
                      <tr>
                        <td class="infoCol">eID :</td>
                        <td><b>{{provisionData["eid"]}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Type :</td>
                        <td><b>{{provisionData["type"]}} ({{provisionData["typeNo"]}})</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">State :</td>
                        <td><b>{{provisionData["state"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['secret'] != undefined">
                        <td class="infoCol">Secret :</td>
                        <td><b>{{provisionData["secret"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['chSecret'] != undefined">
                        <td class="infoCol">Channel Secret :</td>
                        <td><b>{{provisionData["chSecret"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['sync_word'] != undefined">
                        <td class="infoCol">Sync Word :</td>
                        <td><b>{{provisionData["sync_word"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['wifi_mac'] != undefined">
                        <td class="infoCol">WiFi Mac :</td>
                        <td><b>{{provisionData["wifi_mac"]}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Factory Firmware Version :</td>
                        <td><b>{{provisionData["fwVPlain"]}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Current Firmware Version :</td>
                        <td><b>{{provisionData["fwV_str"]}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Hardware Version :</td>
                        <td><b>{{provisionData["hwVersion"]}}{{provisionData["hwVersionName"] ? ' (' + provisionData["hwVersionName"] + ')' : ''}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData.subType != undefined">
                        <td class="infoCol">Sub Type :</td>
                        <td><b>{{provisionData["subType"]}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Device Range :</td>
                        <td><b>{{provisionData["deviceRange"]}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Region :</td>
                        <td><b>{{provisionData["region"]}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Warranty Expiry :</td>
                        <td><b>{{provisionData["warrantyExpiryAt"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['phy_config_capability'] != undefined">
                        <td class="infoCol">Physical Config Capability :</td>
                        <td><b>{{provisionData["phy_config_capability"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['phy_config_mode'] != undefined">
                        <td class="infoCol">Physical Config Mode :</td>
                        <td><b>{{provisionData["phy_config_mode"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['network_config_capability'] != undefined">
                        <td class="infoCol">Network Config Capability :</td>
                        <td><b>{{provisionData["network_config_capability"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['network_config_mode'] != undefined">
                        <td class="infoCol">Network Config Mode :</td>
                        <td><b>{{provisionData["network_config_mode"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['applicationCapability'] != undefined">
                        <td class="infoCol">Application Capability:</td>
                        <td><b>{{provisionData["applicationCapability"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['physicalAttribute'] != undefined">
                        <td class="infoCol">Physical Attribute:</td>
                        <td><b>{{provisionData["physicalAttribute"]}}</b></td>
                      </tr>
                      <tr *ngIf="provisionData['fAt']">
                        <td class="infoCol">Provisioned At :</td>
                        <td><b>{{provisionData["fAt"]}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Current Owner :</td>
                        <td><b>{{provisionData["owner"]}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Com/Decom History :</td>
                        <td>
                          <ul style="padding: 10px;">
                            <li *ngFor="let history of provisionData['comDecomHistory']" style="padding: 5px;"> {{getBeautifiedComDecomHistory(history)}}</li>
                          </ul>
                        </td>
                      </tr>
                    </table>
                  </nb-card-body>
                </nb-card>
  
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Provision' && showCopyProvisionData"
            [nbSpinner]="copyProvisionLoading" nbSpinnerStatus="success">
            <nb-card-header>Copy Provision Data</nb-card-header>
            <nb-card-body>
              <p>Select a downloaded provision JSON file from Production Console. State will be saved as FACTORY.</p>
              <div class="copy-provision-dropzone" [class.is-dragging]="copyProvisionDragging"
                [class.has-file]="copyProvisionFileName" [class.is-disabled]="copyProvisionLoading"
                (dragover)="onCopyProvisionDragOver($event)" (dragleave)="onCopyProvisionDragLeave($event)"
                (drop)="onCopyProvisionDrop($event)">
                <input id="copy-provision-file" class="copy-provision-file" type="file" accept=".json,application/json"
                  aria-label="Choose a provision JSON file" [disabled]="copyProvisionLoading"
                  (change)="onCopyProvisionFileChange($event)">
                <span class="copy-provision-upload-icon" aria-hidden="true"><nb-icon icon="upload-outline"></nb-icon></span>
                <span class="copy-provision-file-title">{{copyProvisionFileName || 'Choose a JSON file'}}</span>
                <span class="copy-provision-file-subtitle">{{copyProvisionFileName ? 'Choose another file or drag and drop' : 'or drag and drop it here'}}</span>
                <span class="copy-provision-file-badge" aria-hidden="true">.JSON</span>
              </div>
              <p *ngIf="copyProvisionFileReading" role="status">Reading selected file…</p>
              <pre *ngIf="copyProvisionTokens.length" class="copy-provision-preview" aria-label="Formatted JSON preview"><code><span *ngFor="let token of copyProvisionTokens" [style.color]="token.color">{{token.text}}</span></code></pre>
              <nb-alert *ngIf="copyProvisionError" status="danger" role="alert">{{copyProvisionError}}</nb-alert>
              <nb-alert *ngIf="copyProvisionMessage" status="success" role="status">{{copyProvisionMessage}}</nb-alert>
              <button nbButton fullWidth status="primary" (click)="copyProvisionData()"
                [disabled]="copyProvisionLoading || copyProvisionFileReading || !copyProvisionDocument">Copy</button>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Change First Com Date'" [nbSpinner]="firstComDateChangeLoading"
            nbSpinnerStatus="success"
            nbSpinnerSize="large"
            nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Change First Commission Date :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter EID(e.g. aa-aa-aa-aa-aa-aa-aa-aa)" style="text-transform: lowercase;" [(ngModel)]="firstComDateChangeEid"/>
                <br>
                <input nbInput fullWidth placeholder="Enter Commissioning Customer Email Id/Mobile" style="text-transform: lowercase;" [(ngModel)]="firstComDateChangeContact"/>
                <br>
                <input nbInput placeholder="Pick Date" [nbDatepicker]="dateTimePicker" [(ngModel)]="firstComDateChangeDate">
                <nb-datepicker #dateTimePicker></nb-datepicker>
                <br>
                <div fxLayoutAlign="row">
                  <b style="margin-right: 10px;">Pick Time :</b>
                  <input type="time" id="appt" name="appt" min="09:00" max="18:00" [(ngModel)]="firstComDateChangeTime" />
                </div>
                <br>
                <button nbButton fullWidth status="primary" (click)="changeFirstComDateV1()" style="margin-left:10px;">Change</button>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Change First Com Date'" [nbSpinner]="firstComDateChangeLoading"
            nbSpinnerStatus="success"
            nbSpinnerSize="large"
            nbSpinnerMessage=""
            style="margin-top:20px;">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Change First Commission Date HUB & Nodes :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter HUB ID(e.g. aa-aa-aa-aa-aa-aa-aa-aa)" style="text-transform: lowercase;" [(ngModel)]="firstComDateChangeHub"/>
                <br>
                <input nbInput placeholder="Pick Date" [nbDatepicker]="dateTimePicker2" [(ngModel)]="firstComDateChangeDateHub">
                <nb-datepicker #dateTimePicker2></nb-datepicker>
                <br>
                <div fxLayoutAlign="row">
                  <b style="margin-right: 10px;">Pick Time :</b>
                  <input type="time" id="appt" name="appt" min="09:00" max="18:00" [(ngModel)]="firstComDateChangeTimeHub" />
                </div>
                <br>
                <button nbButton fullWidth status="primary" (click)="changeFirstComDateV1Hub()" style="margin-left:10px;">Change</button>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Extended Warranty'" [nbSpinner]="firstComDateChangeLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Change Warranty Date :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter EID(e.g. aa-aa-aa-aa-aa-aa-aa-aa)" style="text-transform: lowercase;" [(ngModel)]="firstComDateChangeEid"/>
                <br>
                <input style="width: 100%;" nbInput placeholder="Pick Date" [nbDatepicker]="dateTimePicker" [(ngModel)]="firstComDateChangeDate">
                <nb-datepicker style="width: 100%;" #dateTimePicker></nb-datepicker>
                <br>
                <br>
                <button nbButton fullWidth status="primary" (click)="changeFirstComDate()" style="margin-left:10px;">Change</button>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Extended Warranty'" [nbSpinner]="firstComDateChangeLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="" style="margin-top: 20px;">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Change Warranty Date HUB & Nodes :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter HUB ID(e.g. aa-aa-aa-aa-aa-aa-aa-aa)" style="text-transform: lowercase;" [(ngModel)]="extWarrantyDateChangeEidHub"/>
                <br>
                <input style="width: 100%;" nbInput placeholder="Pick Date" [nbDatepicker]="dateTimePicker2" [(ngModel)]="extWarrantyDateChangeHub">
                <nb-datepicker style="width: 100%;" #dateTimePicker2></nb-datepicker>
                <br>
                <br>
                <button nbButton fullWidth status="primary" (click)="changeFirstComDateHub()" style="margin-left:10px;">Change</button>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Com Decom History'" [nbSpinner]="comDecomHistoryLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Com/Decom History :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter EID(e.g. aa-aa-aa-aa-aa-aa-aa-aa)" style="text-transform: lowercase;" [(ngModel)]="comDecomEid"/>
                <br>
                <button nbButton fullWidth status="primary" (click)="getComDecomHistory()" style="margin-left:10px;">Get History</button>
                <br>
                <br>
                <ag-grid-angular
                  *ngIf="comDecomData.length"
                  style="width: 100%;"
                  class="ag-theme-balham"
                  [columnDefs]="columnDefsComDecomHistory"
                  [defaultColDef]="defaultColDef"
                  [rowData]="comDecomData"
                  [rowSelection]="'multiple'"
                  [domLayout]="domLayout"
                  [animateRows]="true"
                  [enableCellTextSelection]=true
                  (gridReady)="onGridReady($event)"> 
                  </ag-grid-angular>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Locked Accounts'" [nbSpinner]="lockedAccountsLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Locked Accounts :</b>
                <br>
                <button nbButton fullWidth status="success" (click)="getLockedAccounts()" style="margin-left:10px;">Fetch All</button>
                <br>
                <br>
                <ag-grid-angular
                  *ngIf="lockedAccounts.length"
                  style="width: 100%;"
                  class="ag-theme-balham"
                  [columnDefs]="columnDefsLockedAccounts"
                  [defaultColDef]="defaultColDef"
                  [rowData]="lockedAccounts"
                  [rowSelection]="'multiple'"
                  [domLayout]="domLayout"
                  [animateRows]="true"
                  [enableCellTextSelection]=true
                  (gridReady)="onGridReady($event)"> 
                  </ag-grid-angular>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Service Testing'" [nbSpinner]="serviceTestingLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Service Testing :</b>
                <br>
                <nb-alert status="danger">Devices marked as Testing required should not be serviced by Service Engineer without consulting Engineering & Support Team.</nb-alert>
                <br>
                <input nbInput fullWidth placeholder="Enter EID" style="text-transform: lowercase;" [(ngModel)]="serviceTestingEidAdding"/>
                <br>
                <input nbInput fullWidth placeholder="Enter Comment" style="text-transform: lowercase;" [(ngModel)]="serviceTestingComment"/>
                <br>
                <button nbButton fullWidth status="primary" (click)="setServiceTesting()" style="margin-left:10px;">Mark as Testing Required</button>
                <br>
                <br>
                <input nbInput fullWidth placeholder="Enter EID" style="text-transform: lowercase;" [(ngModel)]="serviceTestingEid"/>
                <br>
                <button nbButton fullWidth status="primary" (click)="getServiceTesting()" style="margin-left:10px;">Fetch Info</button>
                <br>
                <button nbButton fullWidth status="success" (click)="getServiceTestingAll()" style="margin-left:10px;">Fetch All</button>
                <br>
                <br>
                <ag-grid-angular
                  *ngIf="serviceTestingData.length"
                  style="width: 100%;"
                  class="ag-theme-balham"
                  [columnDefs]="columnDefsServiceTestingData"
                  [defaultColDef]="defaultColDef"
                  [rowData]="serviceTestingData"
                  [rowSelection]="'multiple'"
                  [domLayout]="domLayout"
                  [animateRows]="true"
                  [enableCellTextSelection]=true
                  (gridReady)="onGridReady($event)"> 
                  </ag-grid-angular>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Kit Info'" [nbSpinner]="kitInfoLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Kit Info :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter Hub ID" style="text-transform: lowercase;" [(ngModel)]="kitHubId"/>
                <br>
                <button nbButton fullWidth status="primary" (click)="getKitInfo()" style="margin-left:10px;">Get Info</button>
                <br>
                <br>
                <ag-grid-angular
                  *ngIf="kitData.length"
                  style="width: 100%;"
                  class="ag-theme-balham"
                  [columnDefs]="columnDefsKitInfo"
                  [defaultColDef]="defaultColDef"
                  [rowData]="kitData"
                  [rowSelection]="'multiple'"
                  [domLayout]="domLayout"
                  [animateRows]="true"
                  [enableCellTextSelection]=true
                  (gridReady)="onGridReady($event)"> 
                </ag-grid-angular>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Scene Details'" [nbSpinner]="sceneDetailsLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center stretch">
                <b>Scene Details :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter Hub ID" style="text-transform: lowercase;" [(ngModel)]="sceneHubId"/>
                <br>
                <input nbInput fullWidth placeholder="Enter Scene Name" [(ngModel)]="sceneName" (keyup.enter)="getSceneDetails()"/>
                <br>
                <button nbButton fullWidth status="primary" (click)="getSceneDetails()">Get Details</button>
                <br>

                <nb-card *ngIf="sceneData" style="width: 100%;">
                  <nb-card-header>{{sceneData.name}}</nb-card-header>
                  <nb-card-body>
                    <table class="provisionData">
                      <tr>
                        <td class="infoCol">Scene ID :</td>
                        <td>
                          <b>{{sceneData._id}}</b>
                          <span *ngIf="sceneData.cloudId !== undefined && sceneData.cloudId !== null">
                            (Cloud ID: {{sceneData.cloudId}})
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="infoCol">Created At :</td>
                        <td><b>{{sceneData.createdAt | date:'medium'}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Updated At :</td>
                        <td><b>{{sceneData.updatedAt | date:'medium'}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Synced :</td>
                        <td><b>{{sceneData.isSynced}}</b></td>
                      </tr>
                      <tr>
                        <td class="infoCol">Deleted :</td>
                        <td><b>{{sceneData.isDeleted}}</b></td>
                      </tr>
                    </table>

                    <h6 class="scene-section-header">Edge Data</h6>
                    <table class="provisionData scene-edge-data" *ngIf="sceneEdgeDataRows.length > 0">
                      <tr>
                        <th>Hub ID</th>
                        <th>Short ID</th>
                        <th>Edge Sync</th>
                      </tr>
                      <tr *ngFor="let edgeData of sceneEdgeDataRows">
                        <td><b>{{edgeData.hubId}}</b></td>
                        <td>{{edgeData.shortId !== undefined ? edgeData.shortId : '—'}}</td>
                        <td>{{edgeData.edgeSync !== undefined ? edgeData.edgeSync : '—'}}</td>
                      </tr>
                    </table>
                    <p *ngIf="sceneEdgeDataRows.length == 0">No edge data found.</p>

                    <h6 class="scene-section-header">App Actions ({{sceneData.appActions.length}})</h6>
                    <nb-accordion>
                      <nb-accordion-item *ngFor="let appAction of sceneData.appActions; let i = index">
                        <nb-accordion-item-header>
                          App Action {{i + 1}} — Hub ID: {{appAction.hubId || '—'}} | Node ID: {{appAction.nodeId !== undefined ? appAction.nodeId : '—'}} | App ID: {{appAction.appId !== undefined ? appAction.appId : '—'}}
                        </nb-accordion-item-header>
                        <nb-accordion-item-body>
                          <table class="provisionData">
                            <tr><td class="infoCol">Hub ID :</td><td><b>{{appAction.hubId}}</b></td></tr>
                            <tr><td class="infoCol">Node ID :</td><td><b>{{appAction.nodeId}}</b></td></tr>
                            <tr><td class="infoCol">App ID :</td><td><b>{{appAction.appId}}</b></td></tr>
                            <tr><td class="infoCol">Action :</td><td><b>{{appAction.action}}</b></td></tr>
                            <tr><td class="infoCol">Type :</td><td><b>{{appAction.type}} ({{getAppActionTypeName(appAction.type)}})</b></td></tr>
                            <tr *ngIf="appAction.settings !== undefined"><td class="infoCol">Settings :</td><td><pre class="scene-json">{{appAction.settings | json}}</pre></td></tr>
                            <tr *ngIf="appAction.ints !== undefined"><td class="infoCol">Ints :</td><td><pre class="scene-json">{{appAction.ints | json}}</pre></td></tr>
                            <tr *ngIf="appAction.strs !== undefined"><td class="infoCol">Strs :</td><td><pre class="scene-json">{{appAction.strs | json}}</pre></td></tr>
                          </table>
                        </nb-accordion-item-body>
                      </nb-accordion-item>
                    </nb-accordion>
                    <p *ngIf="sceneData.appActions.length == 0">No app actions found.</p>

                    <h6 class="scene-section-header">Rule Actions ({{sceneData.ruleActions.length}})</h6>
                    <nb-accordion>
                      <nb-accordion-item *ngFor="let ruleAction of sceneData.ruleActions; let i = index">
                        <nb-accordion-item-header>Rule Action {{i + 1}}</nb-accordion-item-header>
                        <nb-accordion-item-body>
                          <table class="provisionData">
                            <tr><td class="infoCol">Hub IDs :</td><td><b>{{ruleAction.hubIds ? ruleAction.hubIds.join(', ') : ''}}</b></td></tr>
                            <tr><td class="infoCol">Rule ID :</td><td><b>{{ruleAction.ruleId}}</b></td></tr>
                            <tr><td class="infoCol">Should Enable :</td><td><b>{{ruleAction.shouldEnable}}</b></td></tr>
                          </table>
                        </nb-accordion-item-body>
                      </nb-accordion-item>
                    </nb-accordion>
                    <p *ngIf="sceneData.ruleActions.length == 0">No rule actions found.</p>
                  </nb-card-body>
                </nb-card>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Warranty'" [nbSpinner]="warrantyLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Warranty Check :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter EID" [(ngModel)]="warrantyEid"/>
                <br>
                <button nbButton fullWidth status="primary" (click)="checkWarranty()" style="margin-left:10px;">Check Warranty</button>
                <br>
                <br>
                <div fxLayout="column" fxLayoutAlign="center center" *ngIf="isWarrantyGood != 0">
                  <img style="margin-bottom: 20px;" width="150" src="{{isWarrantyGood == 1 ? 'assets/icons/warranty.png' : (isWarrantyGood == -2 ? 'assets/icons/warranty_warning.png' : 'assets/icons/warranty_error.png')}}" alt="" srcset="">
                  <b>{{warrantyMessage}}</b>
                </div>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'De-Blacklist'" [nbSpinner]="deBlackListingLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>De-BlackList HUB/Node :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter EID" [(ngModel)]="deblacklistEid"/>
                <br>
                <input nbInput fullWidth placeholder="Reason" [(ngModel)]="deblacklistReason"/>
                <br>
                <button nbButton fullWidth status="primary" (click)="deblacklist()" style="margin-left:10px;">De-BlackList</button>
                <br>
                <br>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Hub Variant'" [nbSpinner]="hubVariantChangeLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Fix Hub Variant :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter HUB ID dash separated" [(ngModel)]="hubVariantEid"/>
                <br>
                <button nbButton fullWidth status="primary" (click)="changeHubVariant()" style="margin-left:10px;">Change Variant</button>
                <br>
                <br>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Unlock Kit'" [nbSpinner]="unlockKitLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Forceful Unlock Kit :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter HUB ID" style="text-transform: lowercase;" [(ngModel)]="unlockKitHubId"/>
                <br>
                <input nbInput fullWidth placeholder="Reason" [(ngModel)]="unlockKitReason"/>
                <br>
                <nb-select placeholder="Select Approver" [(selected)]="unlockKitApprover" fullWidth>
                  <nb-option value="amit">Amit</nb-option>
                </nb-select>
                <br>
                <button nbButton fullWidth status="primary" (click)="unlockKit()" style="margin-left:10px;">Unlock</button>
                <br>
                <br>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Batch Node OTA'" [nbSpinner]="batchNodeOTALoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Batch Node OTA :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter Node eID dash separated, you can enter multiple eIDs comma separated" style="text-transform: lowercase;" [(ngModel)]="batchNodeOTAEid"/>
                <br>
                <button nbButton fullWidth status="primary" *ngIf="batchNodeOTAEid" (click)="addEidToBatchNodeOTAList()" style="margin-left:10px;">Add</button>
                <br>
                <b *ngIf="batchNodeOTAEids.length">OTA-ing below {{batchNodeOTAEids.length}} Nodes :</b>
                <br>
  
                <nb-list fullWidth>
                  <nb-list-item *ngFor="let bnoe of batchNodeOTAEids">
                    <div>
                      {{ bnoe }}
                      <button style="margin-left: 10px;" nbButton outline size="tiny" status="danger" (click)="removeEidFromBatchNodeOTAList(bnoe)">X</button>
                    </div>
                  </nb-list-item>
                </nb-list>
                <br>
                <br>
                <button nbButton fullWidth status="primary" *ngIf="batchNodeOTAEids.length" (click)="batchNodeOTARequest()" style="margin-left:10px;">Request Batch Node OTA</button>
                <br>
                <br>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Batch Node OTA'" [nbSpinner]="batchNodeOTARequestsLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Pending/Failed Batch Node OTA Requests:</b>
                <br>
                <button nbButton fullWidth status="primary" (click)="batchNodeOTAPendingRequest()" style="margin-left:10px;">Fetch</button>
                <br>
                <br>
                <ag-grid-angular
                            *ngIf="batchNodeOTARequests.length"
                            style="width: 100%;"
                            class="ag-theme-balham"
                            [columnDefs]="defaultColDefBatchNodeOTARequests"
                            [defaultColDef]="defaultColDefBatchNodeOTARequests"
                            [rowData]="batchNodeOTARequests"
                            [rowSelection]="'multiple'"
                            [domLayout]="domLayout"
                            [animateRows]="true"
                            [enableCellTextSelection]=true
                            (gridReady)="onGridReady($event)">
                </ag-grid-angular>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Extract Node Type Data'" [nbSpinner]="extractNodeTypeLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Extract Node Type Data :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter Released Node Types comma separated, e.g IWS_MC_3,IWS_GC_2" [(ngModel)]="extractNodeTypes"/>
                <br>
                <input nbInput fullWidth placeholder="Reason of Extraction" [(ngModel)]="extractNodeTypeReason"/>
                <br>
                <nb-alert status="danger">⚠️ This is a computationally intensive operation and should be used only when absolutely necessary ⚠️</nb-alert>
                <br>
                <button nbButton fullWidth status="primary" [disabled]="extractNodeTypeLoading" (click)="extractNodeType()" style="margin-left:10px;">Extract</button>
                <br>
                <br>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Extract Customer Data'" [nbSpinner]="extractCustomerDataLoading"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body fxLayout="column" fxLayoutAlign="center center">
                <b>Extract Customer Data :</b>
                <br>
                <input nbInput fullWidth placeholder="Enter Customer Email ID or Mobile Number with Country Code" [(ngModel)]="extractCustomerContact"/>
                <br>
                <input nbInput fullWidth placeholder="Reason of Extraction" [(ngModel)]="extractCustomerDataReason"/>
                <br>
                <button nbButton fullWidth status="primary" [disabled]="extractCustomerDataLoading" (click)="extractCustomerData()" style="margin-left:10px;">Extract</button>
                <br>
                <br>
            </nb-card-body>
          </nb-card>
        <!-- <nb-card *ngIf="selectedFeature == 'Change HUB Place'" [nbSpinner]="loadingCustomerInfo"
        nbSpinnerStatus="success"
        nbSpinnerSize="large"
        nbSpinnerMessage="">
          <nb-card-body>
              <b>Change HUB's Place :</b>
              <br>
              <br>
              <div fxLayout="column" fxLayoutAlign="center stretch">
                <input type="text" nbInput fullWidth placeholder="Search by Email ID/Mobile Number" [(ngModel)]="customerContact" [disabled]="dataCustomer['hubIds']">                
                <br>
                <button nbButton status="success" (click)="getHubsAndPlaces()">Get Info</button>
                <br>
                <br>
                <div *ngIf="dataCustomer['hubIds'] && dataCustomer['hubIds'].length > 0">
                  <h6>Select HUB ID :</h6>
                  <br>
                  <nb-select placeholder="Select HUB ID" [(selected)]="selectedHubId" fullWidth>
                    <nb-option value="{{hubId}}" *ngFor="let hubId of dataCustomer['hubIds']">{{hubId}}</nb-option>
                  </nb-select>
                </div>
                <br>
                <div *ngIf="dataCustomer['places'] && dataCustomer['places'].length > 0">
                  <h6>Select Place :</h6>
                  <br>
                  <nb-select placeholder="Select Place" [(selected)]="selectedPlaceId" fullWidth>
                    <nb-option value="{{place.id}}" *ngFor="let place of dataCustomer['places']">{{place["name"]}}-{{place.id}}</nb-option>
                  </nb-select>
                </div>
                <br>
                <button *ngIf="selectedHubId && selectedPlaceId" nbButton status="info" (click)="changeHubPlace()">Change HUB's Place</button>
              </div>
          </nb-card-body>
        </nb-card>   -->
        <nb-card *ngIf="selectedFeature == 'Refresh OTA Buckets'">
              <nb-card-body>
                  <b>Refresh OTA Buckets :</b>
                  <button nbButton status="primary" (click)="refreshOtaBucket()" style="margin-left:10px;">Refresh</button>
              </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Health Data'" [nbSpinner]="loadingHealthData"
          nbSpinnerStatus="success"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
            <nb-card-body>
                <b>Health :</b>
                <br>
                <br>
                <div fxLayout="column" fxLayoutAlign="center stretch">
                  <input type="text" nbInput fullWidth placeholder="Search by eID" [(ngModel)]="healthEid">                
                  <br>
                  <div fxLayout="row" fxLayoutAlign="space-evenly center" style="margin-bottom: 20px;">
                      <input [nbDatepicker]="datepickerHubStart" nbInput placeholder="Start Date" [(ngModel)]="graphStart">
                      <nb-datepicker #datepickerHubStart></nb-datepicker>
                      <b>-</b>
                      <input [nbDatepicker]="datepickerHubEnd" nbInput placeholder="End Date" [(ngModel)]="graphEnd">
                      <nb-datepicker #datepickerHubEnd></nb-datepicker>
                      <nb-checkbox style="margin-left: 20px;" (checkedChange)="showAllHealthDataChangeHub($event)">Show All Points</nb-checkbox>
                  </div>
                  <button nbButton status="success" (click)="getNodeHealth()">Get Health</button>
                  <br>
                  <br>
                  <plotly-plot *ngIf="graph[healthEid]" [data]="graph[healthEid].data" [layout]="graph[healthEid].layout">
                  </plotly-plot>
                  <!-- <br>
                  <b>Old Device Health Data :</b>
                  <br>
                  <input type="text" nbInput fullWidth placeholder="Search by eID" [(ngModel)]="healthEidOld">                
                  <br>
                  <button nbButton status="success" (click)="getNodeHealthOld()">Get Health</button>
                  <br>
                  <br>
                  <plotly-plot *ngIf="graph[healthEidOld]" [data]="graph[healthEidOld].data" [layout]="graph[healthEidOld].layout">
                  </plotly-plot> -->
                </div>
            </nb-card-body>
          </nb-card>
          <nb-card *ngIf="selectedFeature == 'Packet Analyzer'">
            <nb-card-body>
              <b>Packet Analyzer :</b>
              <br>
              <br>
              <app-packet-analyzer>
              </app-packet-analyzer>
            </nb-card-body>
          </nb-card>
          </div>
        </div>
        </nb-tab>

      </nb-tabset>
    </nb-card-body>
  </nb-card>
</div>
